//import { getBase64 } from "../../../../utils/file";
export const snapShot = async ({ props, refs, data }) => {
    const { form } = props;
    const context = refs.canvas.getContext('2d')
    const photoFromVideo = refs.camera
    // const blob = await refs.camera?.snapshot({ width: 450, height: 250 }, "image/png");
    // getBase64(blob, () => {
    //     const reader = new FileReader();
    //     reader.readAsDataURL(blob);
    //     reader.onloadend = () => {
    //         const base64data = reader.result;
    //         props.form.base64 = base64data;
    //     };
    // });
    context.drawImage(photoFromVideo, 0, 0, 450, 337)
    const canvas = document.getElementById("photoTaken").toDataURL("image/png").replace("image/png", "image/octet-stream");
    form.base64 = canvas
    stopCameraStream({ data, refs})
};

export const toggleCamera = ({ data, refs }) => {
    data.isActiveCamera = true
    createCameraElement({ data, refs })
}

export const createCameraElement = ({ data, refs }) => {
    data.isActiveCamera = true
    const constraints = (window.constraints = {
        audio: false,
        video: true,
    });
   
    navigator.mediaDevices
        .getUserMedia(constraints)
        .then((stream) => {
            refs.camera.srcObject = stream;
            console.log("CameraOpen");
        })
        .catch((error) => {
            alert(error, "May the browser didn't support or there is some errors.");
        });
};

export const stopCameraStream = ({ data, refs }) => {
    const tracks = refs.camera.srcObject.getTracks();
    data.isActiveCamera = false
    

    tracks.forEach((track) => {
        track.stop();
    });
    console.log("CameraClosed");
};
